export default __webpack_public_path__ + "static/media/pnsv_stand_Solistica.2d7f8de2.png";